// extracted by mini-css-extract-plugin
module.exports = {"description":"HistoryDetails-description-3KT4b DescriptionListItemDescription-description-3Ul_p"};